import React from 'react';
import { theme } from '../../../theme';
import {
  Home,
  Lightbulb,
  Droplets,
  Car,
  ShoppingBag,
  CheckCircle
} from 'lucide-react';

interface VenueAmenityBadgeProps {
  amenity: string;
  size?: 'small' | 'medium' | 'large';
}

const VenueAmenityBadge: React.FC<VenueAmenityBadgeProps> = ({
  amenity,
  size = 'medium'
}) => {
  const getIcon = (amenityName: string) => {
    const iconSize = size === 'small' ? 16 : size === 'large' ? 24 : 20;
    const lowerAmenity = amenityName.toLowerCase();

    if (lowerAmenity.includes('techado') || lowerAmenity.includes('indoor')) {
      return <Home size={iconSize} />;
    }
    if (lowerAmenity.includes('iluminación') || lowerAmenity.includes('lighting')) {
      return <Lightbulb size={iconSize} />;
    }
    if (lowerAmenity.includes('baño') || lowerAmenity.includes('bathroom')) {
      return <Droplets size={iconSize} />;
    }
    if (lowerAmenity.includes('estacionamiento') || lowerAmenity.includes('parking')) {
      return <Car size={iconSize} />;
    }
    if (lowerAmenity.includes('vestuario') || lowerAmenity.includes('changing')) {
      return <ShoppingBag size={iconSize} />;
    }
    return <CheckCircle size={iconSize} />;
  };

  const getSizeStyles = () => {
    switch (size) {
      case 'small':
        return {
          padding: '6px 12px',
          fontSize: '0.8rem',
          gap: '6px',
        };
      case 'large':
        return {
          padding: '12px 20px',
          fontSize: '1rem',
          gap: '10px',
        };
      default:
        return {
          padding: '8px 16px',
          fontSize: '0.9rem',
          gap: '8px',
        };
    }
  };

  const sizeStyles = getSizeStyles();

  const badgeStyle: React.CSSProperties = {
    display: 'inline-flex',
    alignItems: 'center',
    gap: sizeStyles.gap,
    backgroundColor: theme.colors.surface,
    color: theme.colors.text,
    border: `2px solid ${theme.colors.border}`,
    borderRadius: theme.borderRadius.button,
    padding: sizeStyles.padding,
    fontSize: sizeStyles.fontSize,
    fontWeight: theme.fonts.weightNormal,
    whiteSpace: 'nowrap',
  };

  return (
    <div style={badgeStyle}>
      {getIcon(amenity)}
      <span>{amenity}</span>
    </div>
  );
};

export default VenueAmenityBadge;
